import { IMAGES } from "../../lib/site";
import { Eyebrow, Reveal } from "./Reveal";

export default function BentoGallery() {
    return (
        <section id="metodo" data-testid="bento-gallery" className="border-b border-hairline bg-white px-5 py-24 sm:px-8 md:py-32">
            <div className="mx-auto max-w-6xl">
                <Reveal>
                    <Eyebrow>Il metodo</Eyebrow>
                    <div className="mt-6 flex flex-wrap items-end justify-between gap-6 border-b border-hairline pb-10">
                        <h2 className="max-w-lg text-3xl font-light leading-tight tracking-[-0.02em] text-ink sm:text-5xl">
                            Precisione, respiro,{" "}
                            <em className="font-accent font-medium italic text-ochre">
                                luce naturale
                            </em>
                        </h2>
                        <p className="max-w-xs text-sm font-light leading-relaxed text-body">
                            Metodo Pilates autentico su macchine Reformer Body &amp;
                            Exercise, in uno spazio pensato per rallentare.
                        </p>
                    </div>
                </Reveal>

                <div className="mt-12 grid auto-rows-[150px] grid-cols-2 gap-3 sm:auto-rows-[190px] md:grid-cols-4 md:auto-rows-[210px]">
                    {IMAGES.bento.map((img, i) => (
                        <Reveal key={img.title} delay={i * 0.07} className={img.span} y={20}>
                            <figure
                                data-testid={`bento-item-${i}`}
                                className="group relative h-full w-full overflow-hidden border border-hairline"
                            >
                                <img
                                    src={img.url}
                                    alt={img.title}
                                    loading="lazy"
                                    className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]"
                                />
                                <div className="absolute inset-x-0 bottom-0 border-t border-hairline bg-white/90 px-4 py-3 backdrop-blur-md">
                                    <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-ink">
                                        {img.title}
                                    </p>
                                    <p className="mt-0.5 hidden text-xs font-light text-mute sm:block">
                                        {img.subtitle}
                                    </p>
                                </div>
                            </figure>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
